<template>
	<div class="home" :class="{ 'dark-theme': isDarkMode }">
		<div class="container">
			<!-- Karuzela zdjęć -->
			<div class="carousel-container">
				<div class="carousel">
					<img v-for="(slide, index) in slidesData" :key="index" :src="slide.src" :alt="'Slide ' + index"
						class="carousel-image" :class="{ active: index === currentSlide }" />
				</div>
			</div>

			<!-- Sekcja Lead Magnet (Baner) -->
			<!-- <section class="lead-magnet-banner">
				<h2 class="lead-title">Pobierz darmowy e-book</h2>
				<p class="lead-text">„5 kroków do wdrożenia AI w firmie” – zacznij swoją przygodę z AI już dziś!</p>
				<form @submit.prevent="submitLead" class="lead-form">
					<input type="email" v-model="email" placeholder="Twój e-mail" required class="lead-input" />
					<button type="submit" class="lead-button">Pobierz teraz</button>
				</form>
			</section> -->

			<!-- Pop-up Lead Magnet (opcjonalny)
			<div v-if="showPopup" class="popup-overlay">
				<div class="popup-content">
					<h2 class="lead-title">Darmowy e-book dla Ciebie!</h2>
					<p class="lead-text">Pobierz „5 kroków do wdrożenia AI w firmie” i odkryj, jak AI może pomóc Twojemu
						biznesowi.</p>
					<form @submit.prevent="submitLead" class="lead-form">
						<input type="email" v-model="email" placeholder="Twój e-mail" required class="lead-input" />
						<button type="submit" class="lead-button">Pobierz e-book</button>
					</form>
					<button class="popup-close" @click="showPopup = false">Zamknij</button>
				</div>
			</div> -->

			<!-- Sekcja powitalna -->
			<section class="desc">
				<h2 class="section-title">Przyszłość Twojego biznesu i umiejętności zaczyna się tutaj</h2>
				<p class="intro-text">
					Łączymy innowacyjne rozwiązania AI i IT z indywidualną nauką języka angielskiego, aby zwiększać
					zyski, automatyzować procesy i rozwijać Twoje kompetencje.
				</p>
				<button class="cta-btn" @click="contactUs">Skontaktuj się z nami</button>
			</section>

			<!-- Sekcja Usługi -->
			<section class="services">
				<h2 class="section-title">Usługi</h2>
				<div class="service-list">
					<div class="service" v-for="(service, index) in services" :key="index">
						<img :src="service.icon" class="service-icon" :alt="service.title" v-if="service.icon" />
						<h3 class="service-title">{{ service.title }}</h3>
						<p class="service-desc">{{ service.description }}</p>
						<button class="service-cta" @click="navigateToService(service.title)">Dowiedz się
							więcej</button>
					</div>
				</div>
			</section>

			<!-- Sekcja Indywidualne podejście -->
			<section>
				<h2 class="headline text-uppercase text-center title-red">Indywidualne podejście</h2>
				<h3 class="headline text-center title-blue">Mamy to w DNA!</h3>
			</section>

			<!-- Sekcja wyróżników z obrazem DNA -->
			<img src="@/assets/dna.png" alt="DNA Icon" class="dna-image" />
			<section class="aidesc">
				<v-card>
					<v-card-subtitle class="feature-subtitle">
						<h2 class="title-blue">Co nas wyróżnia?</h2>
					</v-card-subtitle>
					<div class="feature-list">
						<div class="feature-item" v-for="(item, index) in items" :key="index">
							<h3 class="item-title">{{ item.title }}</h3>
							<p class="item-desc">{{ item.description }}</p>
						</div>
					</div>
				</v-card>
			</section>

			<!-- Sekcja News -->
			<section class="news">
				<h2 class="section-title">News</h2>
				<div class="news-list">
					<div class="news-item" v-for="(news, index) in newsItems" :key="index">
						<img :src="news.image" class="news-image" :alt="news.text" />
						<h3 class="news-date"><i class="icon-calendar"></i> {{ news.date }}</h3>
						<span class="news-text">{{ news.text }}</span>
					</div>
				</div>
			</section>

			<v-card-subtitle class="slogan">
				Odkryj nową erę innowacji i edukacji z D4 Quality – AI i angielski w jednym.
			</v-card-subtitle>
			<v-card-text class="details">
				Od automatyzacji procesów po naukę języka angielskiego – nasze rozwiązania wspierają Twój rozwój
				osobisty i biznesowy.
			</v-card-text>
		</div>

		<!-- Powiadomienie o cookies -->
		<div v-if="showCookieBanner" class="cookie-banner">
			<p>Używamy cookies, aby zapewnić najlepszą jakość usług. Klikając "Akceptuję", zgadzasz się na ich użycie
				zgodnie z naszą <a href="/privacy-policy" class="cookie-link">polityką prywatności</a>.</p>
			<button class="cookie-accept" @click="acceptCookies">Akceptuję</button>
		</div>
	</div>
</template>

<script>
export default {
	inject: ['theme'],
	data() {
		return {
			slidesData: [
				{ src: require('@/assets/topic.gif'), title: 'Automatyzacja', description: 'Zrewolucjonizuj swoje procesy z AI' },
			],
			currentSlide: 0,
			services: [
				{ title: 'Sztuczna inteligencja', description: 'Automatyzacja procesów i analiza danych w czasie rzeczywistym.' },
				{ title: 'Konsulting AI', description: 'Strategie AI dostosowane do Twojej branży.' },
				{ title: 'Szkolenia AI', description: 'Praktyczne warsztaty z wdrożenia AI w Twojej firmie.' },
				{ title: 'Nauka angielskiego', description: 'Indywidualne lekcje języka angielskiego na każdym poziomie.' }
			],
			items: [
				{ title: 'Personalizacja', description: 'Rozwiązania AI i lekcje angielskiego szyte na miarę.' },
				{ title: 'Innowacje', description: 'Pionierskie technologie i metody nauczania.' },
				{ title: 'Partnerstwo', description: 'Wsparcie w rozwoju biznesu i umiejętności.' },
				{ title: 'Transparentność', description: 'Pełna kontrola nad procesami i postępami.' },
				{ title: 'Wszechstronność', description: 'Technologia i edukacja w jednym miejscu.' },
			],
			newsItems: [
				{ date: '01.05.2024', text: 'Dołączyliśmy do świata AI', image: require('@/assets/ai-image1.png') },
			],
			email: '',
			showPopup: false,
			showCookieBanner: !localStorage.getItem('cookiesAccepted'), // Pokazuj baner, jeśli cookies nie zaakceptowane
		};
	},
	computed: {
		isDarkMode() {
			return this.theme.isDarkMode;
		},
		currentYear() {
			return new Date().getFullYear(); // Dynamiczny rok w stopce
		},
	},
	methods: {
		contactUs() {
			this.$router.push('/contact');
		},
		navigateToService(serviceTitle) {
			const routes = {
				'Sztuczna inteligencja': '/ai',
				'Konsulting AI': '/consulting',
				'Szkolenia AI': '/courses',
				'Nauka angielskiego': '/english',
			};
			const route = routes[serviceTitle];
			if (route) {
				this.$router.push(route);
			}
		},
		submitLead() {
			console.log("E-mail zapisany:", this.email);
			alert("Dziękujemy! Link do e-booka został wysłany na " + this.email);
			this.email = '';
			this.showPopup = false;
		},
		nextSlide() {
			this.currentSlide = (this.currentSlide + 1) % this.slidesData.length;
		},
		acceptCookies() {
			localStorage.setItem('cookiesAccepted', 'true'); // Zapisz akceptację w localStorage
			this.showCookieBanner = false; // Ukryj baner
		},
	},
	mounted() {
		setInterval(this.nextSlide, 5000);
		setTimeout(() => {
			this.showPopup = true;
		}, 10000);
	},
};
</script>

<style scoped>
/* Ogólne style */
.home {
	font-family: 'Arial', sans-serif;
	transition: all 0.3s ease;
}

.home:not(.dark-theme) {
	background: linear-gradient(135deg, #ffffff 0%, #f1f5f9 100%);
	color: #1f2937;
}

.home.dark-theme {
	background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
	color: #f9fafb;
}

.container {
	max-width: 1200px;
	margin: 0 auto;
	padding: 40px 20px;
}

/* Karuzela */
.carousel-container {
	position: relative;
	margin-bottom: 50px;
}

.carousel {
	position: relative;
	width: 100%;
	height: 450px;
	overflow: hidden;
	border-radius: 12px;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.carousel-image {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	max-width: 100%;
	height: 100%;
	object-fit: cover;
	opacity: 0;
	transition: opacity 0.5s ease-in-out;
}

.carousel-image.active {
	opacity: 1;
}

/* Sekcja Lead Magnet (Baner) */
.lead-magnet-banner {
	background: #f5f5f5;
	padding: 30px;
	border-radius: 12px;
	margin-bottom: 50px;
	text-align: center;
}

.dark-theme .lead-magnet-banner {
	background: #2d2d2d;
}

.lead-title {
	font-size: 2rem;
	font-weight: 700;
	color: #00b4d8;
	margin-bottom: 15px;
}

.lead-text {
	font-size: 1.2rem;
	color: #6b7280;
	margin-bottom: 20px;
}

.dark-theme .lead-text {
	color: #e0e0e0;
}

.lead-form {
	display: flex;
	justify-content: center;
	gap: 10px;
}

.lead-input {
	padding: 10px;
	font-size: 1rem;
	border: 1px solid #ccc;
	border-radius: 6px;
	width: 300px;
}

.dark-theme .lead-input {
	background: #333;
	color: #e0e0e0;
	border-color: #555;
}

.lead-button {
	padding: 10px 20px;
	font-size: 1rem;
	background: #00b4d8;
	color: #fff;
	border: none;
	border-radius: 6px;
	cursor: pointer;
}

.lead-button:hover {
	background: #ff0000;
}

/* Pop-up Lead Magnet */
.popup-overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.6);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 1000;
}

.popup-content {
	background: #fff;
	padding: 30px;
	border-radius: 12px;
	text-align: center;
	max-width: 500px;
	width: 90%;
}

.dark-theme .popup-content {
	background: #2d2d2d;
}

.popup-close {
	margin-top: 20px;
	background: #ff0000;
	color: #fff;
	border: none;
	padding: 8px 16px;
	border-radius: 6px;
	cursor: pointer;
}

.popup-close:hover {
	background: #00b4d8;
}

/* Sekcja powitalna */
.desc {
	margin-bottom: 50px;
	text-align: center;
}

.section-title {
	font-size: 2.5rem;
	font-weight: 700;
	color: #ff0000;
	margin-bottom: 20px;
}

.intro-text {
	font-size: 1.2rem;
	line-height: 1.8;
	margin-bottom: 20px;
}

.cta-btn {
	background: linear-gradient(90deg, #ff0000, #00b4d8);
	color: #fff;
	padding: 12px 24px;
	border: none;
	border-radius: 8px;
	font-size: 1.2rem;
	cursor: pointer;
	transition: transform 0.3s ease;
}

.cta-btn:hover {
	transform: scale(1.05);
}

/* Sekcja Usługi */
.services {
	margin-bottom: 50px;
}

.service-list {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
	gap: 30px;
}

.service {
	background: #fff;
	border-radius: 12px;
	padding: 25px;
	box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
	transition: transform 0.3s ease, box-shadow 0.3s ease;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	min-height: 350px;
}

.dark-theme .service {
	background: #2d2d2d;
}

.service:hover {
	transform: translateY(-5px);
	box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.service-icon {
	width: 50px;
	height: 50px;
	margin-bottom: 20px;
	align-self: center;
}

.service-title {
	font-size: 1.5rem;
	color: #00b4d8;
	margin-bottom: 15px;
	text-align: center;
}

.service-desc {
	font-size: 1.1rem;
	color: #6b7280;
	flex-grow: 1;
	margin-bottom: 20px;
	text-align: center;
}

.service-cta {
	background: #00b4d8;
	color: #fff;
	border: none;
	padding: 10px 20px;
	border-radius: 8px;
	cursor: pointer;
	transition: background 0.3s ease;
	align-self: center;
}

.service-cta:hover {
	background: #ff0000;
}

/* Sekcja wyróżników z obrazem DNA */
.dna-image {
	display: block;
	width: 100%;
	max-width: 800px;
	height: auto;
	margin: 0 auto 20px;
}

.aidesc {
	margin-bottom: 50px;
}

.feature-card {
	background: #fff;
	border-radius: 12px;
	padding: 40px;
	box-shadow: 0 6px 25px rgba(0, 0, 0, 0.1);
	text-align: center;
}

.dark-theme .feature-card {
	background: #2d2d2d;
}

.feature-subtitle h2 {
	font-size: 1.5rem;
	color: #00b4d8;
	margin-bottom: 20px;
}

.feature-list {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
	gap: 20px;
}

.feature-item {
	padding: 20px;
	background: rgba(255, 255, 255, 0.8);
	border-radius: 8px;
	transition: all 0.3s ease;
}

.dark-theme .feature-item {
	background: rgba(45, 45, 45, 0.8);
}

.feature-item:hover {
	transform: translateY(-5px);
	box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.item-title {
	font-size: 1.3rem;
	font-weight: 700;
	color: #ff0000;
	margin-bottom: 8px;
}

.item-desc {
	font-size: 1rem;
	line-height: 1.6;
	color: #6b7280;
}

/* Sekcja News */
.news {
	margin-bottom: 50px;
}

.news-list {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
	gap: 20px;
}

.news-item {
	background: #fff;
	border-radius: 12px;
	padding: 20px;
	box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.dark-theme .news-item {
	background: #2d2d2d;
}

.news-image {
	display: block;
	width: 100%;
	max-width: 300px;
	height: 200px;
	object-fit: cover;
	border-radius: 8px;
	margin: 0 auto 10px;
}

.news-date {
	font-size: 1.1rem;
	color: #00b4d8;
	margin-bottom: 10px;
}

.news-text {
	display: block;
	font-size: 1.2rem;
	margin-bottom: 15px;
}

.news-link {
	color: #00b4d8;
	text-decoration: none;
	font-weight: 600;
}

.news-link:hover {
	color: #ff0000;
}

/* Slogan i szczegóły */
.slogan {
	font-size: 1.1rem;
	font-style: italic;
	color: #00b4d8;
	text-align: center;
	margin-bottom: 15px;
}

.details {
	font-size: 1rem;
	line-height: 1.6;
	text-align: center;
}

/* Stopka */
.footer {
	margin-top: 40px;
	text-align: center;
	font-size: 0.9rem;
	color: #6b7280;
}

.dark-theme .footer {
	color: #e0e0e0;
}

.footer-link {
	color: #00b4d8;
	text-decoration: none;
}

.footer-link:hover {
	color: #ff0000;
}

.rodo-text {
	margin-top: 10px;
}

/* Powiadomienie o cookies */
.cookie-banner {
	position: fixed;
	bottom: 0;
	left: 0;
	width: 100%;
	background: #f5f5f5;
	padding: 15px;
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 20px;
	box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
	z-index: 1000;
}

.dark-theme .cookie-banner {
	background: #2d2d2d;
}

.cookie-banner p {
	margin: 0;
	font-size: 0.9rem;
	color: #6b7280;
}

.dark-theme .cookie-banner p {
	color: #e0e0e0;
}

.cookie-link {
	color: #00b4d8;
	text-decoration: none;
}

.cookie-link:hover {
	color: #ff0000;
}

.cookie-accept {
	background: #00b4d8;
	color: #fff;
	border: none;
	padding: 8px 16px;
	border-radius: 6px;
	cursor: pointer;
}

.cookie-accept:hover {
	background: #ff0000;
}

/* Responsywność */
@media (max-width: 768px) {
	.carousel {
		height: 200px;
	}

	.section-title,
	.lead-title {
		font-size: 1.8rem;
	}

	.intro-text,
	.lead-text {
		font-size: 1rem;
	}

	.lead-form {
		flex-direction: column;
		gap: 15px;
	}

	.lead-input {
		width: 100%;
	}

	.service-list,
	.feature-list,
	.news-list {
		grid-template-columns: 1fr;
	}

	.service {
		min-height: 300px;
	}

	.service-title {
		font-size: 1.3rem;
	}

	.service-desc {
		font-size: 1rem;
	}

	.dna-image {
		max-width: 250px;
	}

	.cookie-banner {
		flex-direction: column;
		gap: 10px;
		padding: 10px;
	}
}

@media (max-width: 480px) {
	.carousel {
		height: 150px;
	}

	.section-title,
	.lead-title {
		font-size: 1.5rem;
	}

	.intro-text,
	.lead-text {
		font-size: 0.9rem;
	}

	.service {
		min-height: 280px;
	}

	.service-title {
		font-size: 1.2rem;
	}

	.service-desc {
		font-size: 0.9rem;
	}

	.dna-image {
		max-width: 200px;
	}

	.news-image {
		height: 150px;
	}
}
</style>